module.exports = __webpack_public_path__ + "img/partner@2x.b188d5ec.png";